/** Add calendar days to an ISO date (YYYY-MM-DD), timezone-safe via UTC noon anchor. */
export function addDaysToIsoDate(isoDate: string, days: number): string | null {
  const trimmed = isoDate.trim();
  if (!trimmed) return null;
  const offset = Math.trunc(days);
  if (!Number.isFinite(offset)) return null;
  const d = new Date(`${trimmed}T12:00:00.000Z`);
  if (Number.isNaN(d.getTime())) return null;
  d.setUTCDate(d.getUTCDate() + offset);
  return d.toISOString().slice(0, 10);
}

export function dueDateFromPaymentTerms(
  baseDate: string | null | undefined,
  paymentTermsDays: number | null | undefined,
): string | null {
  if (paymentTermsDays == null || paymentTermsDays < 0) return null;
  if (!baseDate?.trim()) return null;
  return addDaysToIsoDate(baseDate, paymentTermsDays);
}
